/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import {
  Title,
  CloseContainer,
  Subtitle,
  Form,
  InputWrapper,
  StyledMailIcon,
  Input,
  StyledLockIcon,
  StyledVisibility,
  StyledVisibilityOff,
  ForgotPwContainer,
  ForgotPw,
  ButtonContainer,
  SubmitButton,
  StyledCompanyIcon,
  StyledUserIcon,
  LastNameInput,
  StyledInput,
  Row,
} from "./SignModal.styles";
import Modal from "./Modal2";
import { ReactComponent as CloseIcon } from "../../assets/icons/close.svg";
import { ReactComponent as ChevronIcon } from "../../assets/icons/chevron-left.svg";
import Icon from "../Icon";
import { isValidEmail, isValidPassword } from "../../utils/utils";
import openToast from "../../utils/toast";
import { useDispatch } from "react-redux";
import { setBusinessUserInfo } from "../../store/slices/businessUser/slice";
import { getBusinessRulesVariables } from "../../store/slices/common/asyncThunks";
import logService from "../../api/services/log";
import {
  login,
  sendCodeForNewPassword,
  signUp,
} from "../../store/slices/auth/asyncThunks";
import {
  selectCreateAccountPending,
  selectLoginPending,
  selectSendingResetPending,
  setEmailInput,
} from "../../store/slices/auth/slice";
import { useSelector } from "react-redux";
import { ReactComponent as Loading } from "../../assets/icons/loader-white.svg";
import { getCountFavoriteMarketplaceItems } from "../../store/slices/marketplace/asyncThunks";
import { signUpRecipient } from "../../store/slices/authRecipient/asyncThunks";
import { useLocation } from "react-router-dom";

const SignModal = ({ open, close, ar, t, navigate, isSignUp }) => {
  const dispatch = useDispatch();
  const toastId = useRef(null);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const inviteToken = queryParams.get("inviteToken");

  const loginLoading = useSelector(selectLoginPending);
  const signUpLoading = useSelector(selectCreateAccountPending);
  const resetPasswordLoading = useSelector(selectSendingResetPending);

  const [visibility, setVisibility] = useState(false);
  const [visibility2, setVisibility2] = useState(false);
  const [checkValidation, setCheckValidation] = useState(false);
  const [tab, setTab] = useState("");

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");

  const fullName = `${firstName}  ${lastName}`;

  useEffect(() => {
    if (isSignUp) {
      setTab("sign-up");
    } else {
      setTab("login");
    }
  }, []);

  const resetStates = () => {
    setEmail("");
    setPassword("");
    setConfirmPassword("");
    setCompanyName("");
    setFirstName("");
    setLastName("");
    setVisibility(false);
    setVisibility2(false);
  };

  const handleVisibilityToggle = () => {
    setVisibility(!visibility);
  };
  const handleVisibilityToggle2 = () => {
    setVisibility2(!visibility2);
  };

  const handleLogin = () => {
    setCheckValidation(true);
    if (!email || !password) {
      openToast(
        toastId,
        "login",
        "error",
        t("please-enter-correct-email-and-password")
      );
      return;
    }
    dispatch(login({ email, password }))
      .unwrap()
      .then((response) => {
        const { businessUser } = response;
        dispatch(setBusinessUserInfo(businessUser));
        dispatch(getBusinessRulesVariables());
        dispatch(getCountFavoriteMarketplaceItems());

        if (!businessUser.verified) {
          openToast(
            toastId,
            "waring-login",
            "warning",
            t("please-check-your-email-and-verify-your-account")
          );
        }
        close();
        setEmail("");
        setPassword("");
      })
      .catch(async (err) => {
        openToast(toastId, "login", "error", t(err.message));
        const excludeErrors = ["Wrong password", "Business user not found"];
        if (!excludeErrors.includes(err.message)) {
          await logService.createErrorLog({
            type: "bp_log_in_error",
            data: JSON.stringify({ error: err.message, email }),
          });
        }
      });
  };

  const handleSignup = () => {
    setCheckValidation(true);
    if (inviteToken) {
      if (validateForm()) {
        dispatch(signUpRecipient({ email, fullName, password, inviteToken }))
          .unwrap()
          .then((response) => {
            openToast(
              toastId,
              "success-sign-up",
              "success",
              t("account-created-successfully")
            );
            navigate("/admin-portal/dashboard");
            const { businessUser } = response;
            dispatch(setBusinessUserInfo(businessUser));
            dispatch(getBusinessRulesVariables());
          })
          .catch((error) => {
            openToast(toastId, "sign-up", "error", t(error.message));
          });
      }
    } else {
      if (validateForm()) {
        dispatch(
          signUp({
            email,
            password,
            fullName,
            companyName,
          })
        )
          .unwrap()
          .then((response) => {
            openToast(
              toastId,
              "success-sign-up",
              "success",
              t("account-created-successfully")
            );
            navigate("/admin-portal/dashboard");
            const { businessUser } = response;
            dispatch(setBusinessUserInfo(businessUser));
            dispatch(getBusinessRulesVariables());
          })
          .catch(async (error) => {
            openToast(toastId, "sign-up", "error", t(error.message));
            await logService.createErrorLog({
              type: "bp_sign_in_error",
              data: JSON.stringify({
                error: error.message,
                email,
                fullName,
                companyName,
              }),
            });
          });
      }
    }
  };

  const handleSendEmailWithCode = () => {
    dispatch(sendCodeForNewPassword(email))
      .unwrap()
      .then((response) => {
        openToast(
          toastId,
          "success-reset-password",
          "success",
          t("email-successfully-sent")
        );
        close();
      })
      .catch((error) => {
        openToast(
          toastId,
          "forgot-password-email-send",
          "error",
          t(error.message)
        );
      });
  };

  const validateForm = () => {
    let formIsValid = true;

    if (!inviteToken) {
      if (!companyName) {
        openToast(toastId, "sign-up", "error", t("company-name-is-required"));
        formIsValid = false;
        return;
      }
    }

    if (!firstName) {
      openToast(toastId, "sign-up", "error", t("first-name-is-required"));
      formIsValid = false;
      return;
    }

    if (!lastName) {
      openToast(toastId, "sign-up", "error", t("last-name-is-required"));
      formIsValid = false;
      return;
    }
    if (!email) {
      openToast(toastId, "sign-up", "error", t("email-is-required"));
      formIsValid = false;
      return;
    } else if (!isValidEmail(email)) {
      openToast(toastId, "sign-up", "error", t("invalid-email-format"));

      formIsValid = false;
      return;
    }

    if (!password) {
      openToast(toastId, "sign-up", "error", t("password-is-required"));
      formIsValid = false;
      return;
    } else if (!isValidPassword(password)) {
      openToast(toastId, "sign-up", "info", t("password-contain"));
      formIsValid = false;
      return;
    }

    if (!confirmPassword) {
      openToast(toastId, "sign-up", "error", t("confirm-password-is-required"));
      formIsValid = false;
      return;
    } else if (confirmPassword !== password) {
      openToast(toastId, "sign-up", "error", t("password-dont-match"));
      formIsValid = false;
      return;
    }

    return formIsValid;
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter" && open && tab === "login") {
      handleLogin();
    } else if (e.key === "Enter" && open && tab === "sign-up") {
      handleSignup();
    } else if (e.key === "Enter" && open && tab === "reset-password") {
      handleSendEmailWithCode();
      dispatch(setEmailInput(email));
    }
  };

  useEffect(() => {
    document.addEventListener("keypress", handleKeyPress);

    return () => {
      document.removeEventListener("keypress", handleKeyPress);
    };
  }, [handleKeyPress]);

  return (
    <Modal
      onClose={close}
      open={open}
      right
      responsive
      width={"567px"}
      height={"100%"}
      padding={"50px 60px"}
      unset
    >
      {tab === "login" && (
        <>
          <CloseContainer onClick={close}>
            <CloseIcon fill="white" width={24} height={24} />
          </CloseContainer>
          <Title>{t("sign-in")}</Title>
          <Subtitle>{t("sign-in-with-your-email-address")}</Subtitle>

          <Form>
            <InputWrapper>
              <Icon
                icon={<StyledMailIcon className="login__icon" />}
                selectedLocale={ar}
              />
              <Input
                type="text"
                $ar={ar}
                placeholder={t("email-address")}
                $error={checkValidation && (!isValidEmail(email) || !email)}
                name="email"
                autoComplete="on"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </InputWrapper>
            <InputWrapper>
              <Icon
                icon={<StyledLockIcon className="login__icon" />}
                selectedLocale={ar}
              />

              <Input
                $ar={ar}
                type={visibility ? "text" : "password"}
                placeholder={t("password")}
                name="password"
                $error={checkValidation && !password}
                autoComplete="off"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              {visibility ? (
                <Icon
                  icon={
                    <StyledVisibility
                      className="login__icon_right"
                      onClick={handleVisibilityToggle}
                    />
                  }
                  selectedLocale={ar}
                />
              ) : (
                <Icon
                  icon={
                    <StyledVisibilityOff
                      className="login__icon_right"
                      onClick={handleVisibilityToggle}
                    />
                  }
                  selectedLocale={ar}
                />
              )}
            </InputWrapper>

            <ForgotPwContainer>
              <ForgotPw
                onClick={() => {
                  resetStates();
                  setTab("sign-up");
                }}
              >
                {t("create-new-account")}
              </ForgotPw>
              <ForgotPw
                onClick={() => {
                  resetStates();
                  setTab("reset-password");
                }}
              >
                {t("forgot-password")}
              </ForgotPw>
            </ForgotPwContainer>
          </Form>
          {!loginLoading ? (
            <ButtonContainer>
              <SubmitButton onClick={handleLogin}>{t("sign-in")}</SubmitButton>
            </ButtonContainer>
          ) : (
            <ButtonContainer>
              <SubmitButton disabled>
                <Loading height={30} />
              </SubmitButton>
            </ButtonContainer>
          )}
        </>
      )}
      {tab === "sign-up" && (
        <>
          <CloseContainer
            onClick={() => {
              resetStates();
              setTab("login");
            }}
          >
            <ChevronIcon fill="white" width={32} height={32} />
          </CloseContainer>
          <Title>{t("sign-up")}</Title>
          <Subtitle>{t("create-your-free-account")}</Subtitle>

          <Form>
            {!inviteToken && (
              <InputWrapper>
                <Icon
                  icon={<StyledCompanyIcon className="login__icon" />}
                  selectedLocale={ar}
                />

                <Input
                  $ar={ar}
                  type="text"
                  $error={checkValidation && !companyName}
                  placeholder={t("company-name")}
                  value={companyName}
                  onChange={(e) => {
                    const inputValue = e.target.value;
                    const transformedValue =
                      inputValue.charAt(0).toUpperCase() + inputValue.slice(1);
                    setCompanyName(transformedValue);
                  }}
                />
              </InputWrapper>
            )}

            <Row>
              <InputWrapper>
                <Icon
                  icon={<StyledUserIcon className="login__icon" />}
                  selectedLocale={ar}
                />

                <StyledInput
                  $ar={ar}
                  $error={checkValidation && !firstName}
                  type="text"
                  placeholder={t("first-name")}
                  value={firstName}
                  onChange={(e) => {
                    const inputValue = e.target.value;
                    const transformedValue =
                      inputValue.charAt(0).toUpperCase() + inputValue.slice(1);
                    setFirstName(transformedValue);
                  }}
                />
              </InputWrapper>
              <InputWrapper>
                <LastNameInput
                  type="text"
                  $error={checkValidation && !lastName}
                  placeholder={t("last-name")}
                  value={lastName}
                  onChange={(e) => {
                    const inputValue = e.target.value;
                    const transformedValue =
                      inputValue.charAt(0).toUpperCase() + inputValue.slice(1);
                    setLastName(transformedValue);
                  }}
                />
              </InputWrapper>
            </Row>

            <InputWrapper>
              <Icon
                icon={<StyledMailIcon className="login__icon" />}
                selectedLocale={ar}
              />
              <Input
                type="text"
                $ar={ar}
                placeholder={t("email-address")}
                $error={checkValidation && (!isValidEmail(email) || !email)}
                name="email"
                autoComplete="on"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </InputWrapper>
            <InputWrapper>
              <Icon
                icon={<StyledLockIcon className="login__icon" />}
                selectedLocale={ar}
              />

              <Input
                $ar={ar}
                type={visibility ? "text" : "password"}
                placeholder={t("password")}
                name="password"
                $error={checkValidation && !password}
                autoComplete="off"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              {visibility ? (
                <Icon
                  icon={
                    <StyledVisibility
                      className="login__icon_right"
                      onClick={handleVisibilityToggle}
                    />
                  }
                  selectedLocale={ar}
                />
              ) : (
                <Icon
                  icon={
                    <StyledVisibilityOff
                      className="login__icon_right"
                      onClick={handleVisibilityToggle}
                    />
                  }
                  selectedLocale={ar}
                />
              )}
            </InputWrapper>
            <InputWrapper>
              <Icon
                icon={<StyledLockIcon className="login__icon" />}
                selectedLocale={ar}
              />
              <Input
                $ar={ar}
                type={visibility2 ? "text" : "password"}
                placeholder={t("confirm-password")}
                $error={
                  checkValidation &&
                  (!confirmPassword || password !== confirmPassword)
                }
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
              {visibility2 ? (
                <Icon
                  icon={
                    <StyledVisibility
                      className="login__icon_right"
                      onClick={handleVisibilityToggle2}
                    />
                  }
                  selectedLocale={ar}
                />
              ) : (
                <Icon
                  icon={
                    <StyledVisibilityOff
                      className="login__icon_right"
                      onClick={handleVisibilityToggle2}
                    />
                  }
                  selectedLocale={ar}
                />
              )}
            </InputWrapper>
          </Form>

          {!signUpLoading ? (
            <ButtonContainer>
              <SubmitButton onClick={handleSignup}>{t("sign-up")}</SubmitButton>
            </ButtonContainer>
          ) : (
            <ButtonContainer>
              <SubmitButton disabled>
                <Loading height={30} />
              </SubmitButton>
            </ButtonContainer>
          )}
        </>
      )}
      {tab === "reset-password" && (
        <>
          <CloseContainer
            onClick={() => {
              resetStates();
              setTab("login");
            }}
          >
            <ChevronIcon fill="white" width={32} height={32} />
          </CloseContainer>
          <Title>{t("reset-password")}</Title>
          <Subtitle>{t("set-up-new-password")}</Subtitle>

          <Form>
            <InputWrapper>
              <StyledMailIcon className="login__icon" $ar={ar} />
              <Input
                $ar={ar}
                type="text"
                placeholder={t("email-address")}
                name="email"
                autoComplete="on"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </InputWrapper>
          </Form>

          {!resetPasswordLoading ? (
            <ButtonContainer>
              <SubmitButton
                onClick={() => {
                  if (!email) {
                    openToast(
                      toastId,
                      "sign-up",
                      "error",
                      t("email-is-required")
                    );
                    return;
                  } else if (!isValidEmail(email)) {
                    openToast(
                      toastId,
                      "sign-up",
                      "error",
                      t("invalid-email-format")
                    );
                    return;
                  } else {
                    handleSendEmailWithCode();
                    dispatch(setEmailInput(email));
                  }
                }}
              >
                {t("reset")}
              </SubmitButton>
            </ButtonContainer>
          ) : (
            <ButtonContainer>
              <SubmitButton disabled>
                <Loading height={30} />
              </SubmitButton>
            </ButtonContainer>
          )}
        </>
      )}
    </Modal>
  );
};

export default SignModal;
